import React from 'react';
import { Button } from 'antd';
import { PageConstant } from '../../../constants';
import HmFlow from '../../../assets/img/hm-flow.svg';

const defaultTitle = "Congratulations on completing this fast-track application!";
const DefaultDescription = () => <span>
    We appreciate your effort in completing our vetting process.
    Our team will carefully review your submission and may contact you for additional details if required. 
    Once your application is approved, your profile will be positioned for potential remote jobs. 
    <span className="completion-reminder"> &nbsp;Remember to always keep your work availability up to date!</span>
</span>

const BarRaiserDescription = () => <span>
    Great, you’ve taken all the required steps for this job. We’ll reach out after you complete the interview. 
    <span className="completion-reminder"> &nbsp;Remember to always keep your work availability up to date!</span>
</span>

const FastrackCompleteCard = ({ title, description, infos, service }) => {
    const { flow } = infos;
    const { workflow_path } = flow;
    const completed_title = title || defaultTitle;
    const completed_description = workflow_path === 'bar-raiser' ? <BarRaiserDescription /> : description || <DefaultDescription />
    const redirectLink = PageConstant.DASHBOARD_DEV;

    return (
        <div className='Vetsmith-item completed-section'>
            <div className="completed-section-image">
                <img src={HmFlow} />
            </div>
            <div className='completed-section-content'>
                <div className='completed-title'>{completed_title}</div>
                <div className='completed-description'>{completed_description}</div>
                <Button type="primary" onClick={() => {
                    localStorage.removeItem('redirect_url');
                    service.createPassword(redirectLink)
                }}>Go back to Talent Portal</Button>
            </div>
        </div>
    );
}

export default React.memo(FastrackCompleteCard);